import { render, staticRenderFns } from "./BrokerFieldUpdated.vue?vue&type=template&id=2c2eceb6&"
import script from "./BrokerFieldUpdated.vue?vue&type=script&lang=ts&"
export * from "./BrokerFieldUpdated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports